export default "__VITE_ASSET__5G99IwyL$knLgb1_rwqsQw__"